import { useQuery } from '@apollo/client'
import { ExpensablesStatusCountsDocument } from 'generated/resources/graphql'

import type { StatusCounts } from './useExpensesPresetsConfig'

interface UseExpensablesStatusCountsParams {
  companyId: string
  employeeIds?: string[]
  groupId?: string
  includeManualDrafts?: boolean
  from?: Date
  to?: Date
}

interface UseExpensablesStatusCountsResult {
  data: StatusCounts | undefined
  loading: boolean
}

export const useExpensablesStatusCounts = ({
  companyId,
  employeeIds,
  groupId,
  includeManualDrafts,
  from,
  to,
}: UseExpensablesStatusCountsParams): UseExpensablesStatusCountsResult => {
  const { data, loading, previousData } = useQuery(ExpensablesStatusCountsDocument, {
    variables: {
      companyId,
      employeeIds,
      groupIds: groupId ? [groupId] : undefined,
      includeManualDrafts,
      from,
      to,
    },
    fetchPolicy: 'cache-and-network',
  })

  // Use previousData while loading to prevent counters from disappearing
  const activeData = data ?? previousData

  if (!activeData) {
    return { data: undefined, loading }
  }

  return {
    data: {
      draft: activeData.expenses.draftCount.totalCount ?? 0,
      pending: activeData.expenses.pendingCount.totalCount ?? 0,
      approved: activeData.expenses.approvedCount.totalCount ?? 0,
      paid: activeData.expenses.paidCount.totalCount ?? 0,
    },
    loading,
  }
}
